import { Cart, User } from 'core/domains';
import { useCommand } from 'core/use-cases/utilities';

import { actions } from '../slice';

/**
 * Exports content dispatch commands.
 *
 */
export function useUserCommand() {
  const { dispatchCommand } = useCommand();

  /**
   * Set shipping model search input
   *
   */
  function cleanSearchInput() {
    dispatchCommand(actions.setSearchInput(''));
  }

  /**
   * Set shipping model search input
   *
   */
  function setSearchInput(searchInput: User['shippingModelSearch']) {
    dispatchCommand(actions.setSearchInput(searchInput));
  }

  /**
   * Set search tracking input
   *
   */
  function setSearchTracking(searchInput: User['shippingModelSearch']) {
    dispatchCommand(actions.setSearchTracking(searchInput));
  }

  /**
   * Set buy intention
   *
   */
  function setBuyIntention(
    productCode: Cart['data']['items'][number]['productCode'],
    name: string,
  ) {
    dispatchCommand(actions.userBuyIntentionFetch.request({ productCode, quantity: 1, name }));
  }

  return {
    cleanSearchInput,
    setBuyIntention,
    setSearchInput,
    setSearchTracking,
  };
}
